import React, { ReactNode } from "react";
import { ToastProvider } from "../../hook/useToast";
import { LoginModalProvider } from "../../contexts/LoginModalContext";
import { UserProvider } from "../../contexts/UserContext";

export const RootWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <LoginModalProvider>
      <ToastProvider>
        <UserProvider>{children}</UserProvider>
      </ToastProvider>
    </LoginModalProvider>
  );
};
